import { stageGeneratorParent } from "../stageGeneratorParent.js"
export class primaryBigScreenGenerator extends stageGeneratorParent {
  constructor(opt) {
    super()
    this.container_id = 0
    this.width = 1920
    this.height = 1080
    this.isActive = false
    this.children = []
    this.options = {
      opacity: 100,
      openBgSet: false,
      background: [
        {
          type: "color",
          label: "颜色",
          isThemeColor: false,
          color: "#00043A"
        }
      ]
    }
    this.objDiff(this, opt)
  }
}

export class primaryBigScreenPageLayoutGenerator extends stageGeneratorParent {
  constructor(opt) {
    super()
    switch(opt){
      case 1:
        this.options= {
          bg: [],
          padding: [0, 0, 0, 0],
          opacity: 100,
          height: 200,
          paddingTypeFlag: 2,
          isFullPage: false,
          inDocument:'none',
          isFixed:false,
          isShow:true
        },
          this.id = 1,
          this.layout= {
            rows:[
              {
                id:0,
                options: {
                  padding: [0, 0, 0, 0],
                  bg: [],
                  height: 200,
                  width: "100%",
                  borderTypeFlag:1,
                  borderRadius:[0,0,0,0],
                  borderWidth:0,
                  borderStyle:"solid",
                  borderColor:"rgba(0,0,0,0)",
                  borderIsThemeColor:false
                },
                rectIds: [],
                layout: {
                  rows: [],
                  cols: []
                }
              }
            ]
          }
        break
      case 2:
        this.options= {
          bg: [],
          padding: [40, 0, 40, 0],
          opacity: 100,
          height: 200,
          paddingTypeFlag: 2,
          isFullPage: false,
          inDocument:'none',
          isFixed:false,
          isShow:true
        },
          this.id = 1,
          this.layout= {
            rows:[
              {
                id:0,
                options: {
                  padding: [0, 0, 0, 0],
                  bg: [],
                  height: 200,
                  width: "100%",
                  borderTypeFlag:1,
                  borderRadius:[0,0,0,0],
                  borderWidth:0,
                  borderStyle:"solid",
                  borderColor:"rgba(0,0,0,0)",
                  borderIsThemeColor:false
                },
                rectIds: [],
                layout: {
                  rows: [],
                  cols: [
                    {
                      id:0,
                      options:{
                        padding: [0, 0, 0, 0],
                        bg: [],
                        height: 200,
                        width: "50%",
                        borderTypeFlag:1,
                        borderRadius:[0,0,0,0],
                        borderWidth:0,
                        borderStyle:"solid",
                        borderColor:"rgba(0,0,0,0)",
                        borderIsThemeColor:false
                      },
                      rectIds: [],
                      layout: {
                        rows:[],
                        cols:[]
                      }
                    }, {
                      id:1,
                      options:{
                        padding: [0, 0, 0, 0],
                        bg: [],
                        height: 200,
                        width: "50%",
                        borderTypeFlag:1,
                        borderRadius:[0,0,0,0],
                        borderWidth:0,
                        borderStyle:"solid",
                        borderColor:"rgba(0,0,0,0)",
                        borderIsThemeColor:false
                      },
                      rectIds: [],
                      layout: {
                        rows:[],
                        cols:[]
                      }
                    }
                  ]
                }
              }
            ]
          }
        break
      case 3:
        this.id =1,
          this.options= {
            bg: [],
            padding: [40, 0, 40, 0],
            opacity: 100,
            height: 200,
            paddingTypeFlag: 2,
            isFullPage: false,
            inDocument:'none',
            isFixed:false,
            isShow:true
          },
          this.layout= {
            rows:[
              {
                id:0,
                options: {
                  padding: [0, 0, 0, 0],
                  bg: [],
                  height: 300,
                  width: "100%",
                  borderTypeFlag:1,
                  borderRadius:[0,0,0,0],
                  borderWidth:0,
                  borderStyle:"solid",
                  borderColor:"rgba(0,0,0,0)",
                  borderIsThemeColor:false
                },
                rectIds: [],
                layout: {
                  rows: [
                    {
                      id:0,
                      options:{
                        padding: [0, 0, 0, 0],
                        bg: [],
                        height: 100,
                        width: "100%",
                        borderTypeFlag:1,
                        borderRadius:[0,0,0,0],
                        borderWidth:0,
                        borderStyle:"solid",
                        borderColor:"rgba(0,0,0,0)",
                        borderIsThemeColor:false
                      },
                      rectIds: [],
                      layout: {
                        rows:[],
                        cols:[]
                      }
                    },
                    {
                      id:1,
                      options:{
                        padding: [0, 0, 0, 0],
                        bg: [],
                        height: 200,
                        width: "100%",
                        borderTypeFlag:1,
                        borderRadius:[0,0,0,0],
                        borderWidth:0,
                        borderStyle:"solid",
                        borderColor:"rgba(0,0,0,0)",
                        borderIsThemeColor:false
                      },
                      rectIds: [],
                      layout: {
                        rows:[],
                        cols:[
                          {
                            id:0,
                            options:{
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 200,
                              width: "50%",
                              borderTypeFlag:1,
                              borderRadius:[0,0,0,0],
                              borderWidth:0,
                              borderStyle:"solid",
                              borderColor:"rgba(0,0,0,0)",
                              borderIsThemeColor:false
                            },
                            rectIds: [],
                            layout: {
                              rows:[],
                              cols:[]
                            }
                          },
                          {
                            id:1,
                            options:{
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 200,
                              width: "50%",
                              borderTypeFlag:1,
                              borderRadius:[0,0,0,0],
                              borderWidth:0,
                              borderStyle:"solid",
                              borderColor:"rgba(0,0,0,0)",
                              borderIsThemeColor:false
                            },
                            rectIds: [],
                            layout: {
                              rows:[],
                              cols:[]
                            }
                          }
                        ]
                      }
                    },
                  ],
                  cols: []
                }
              }
            ]
          }
        break
      case 4:
        this.id = 1,
          this.options= {
            bg: [],
            padding: [40, 0, 40, 0],
            opacity: 100,
            height: 400,
            paddingTypeFlag: 2,
            isFullPage: false,
            inDocument:'none',
            isFixed:false,
            isShow:true
          },
          this.layout= {
            rows:[
              {
                id:0,
                options: {
                  padding: [0, 0, 0, 0],
                  bg: [],
                  height: 400,
                  width: "100%",
                  borderTypeFlag:1,
                  borderRadius:[0,0,0,0],
                  borderWidth:0,
                  borderStyle:"solid",
                  borderColor:"rgba(0,0,0,0)",
                  borderIsThemeColor:false
                },
                rectIds: [],
                layout: {
                  rows: [
                    {
                      id:0,
                      options:{
                        padding: [0, 0, 0, 0],
                        bg: [],
                        height: 200,
                        width: "100%",
                        borderTypeFlag:1,
                        borderRadius:[0,0,0,0],
                        borderWidth:0,
                        borderStyle:"solid",
                        borderColor:"rgba(0,0,0,0)",
                        borderIsThemeColor:false
                      },
                      rectIds: [],
                      layout: {
                        rows:[],
                        cols:[
                          {
                            id:0,
                            options:{
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 200,
                              width: "50%",
                              borderTypeFlag:1,
                              borderRadius:[0,0,0,0],
                              borderWidth:0,
                              borderStyle:"solid",
                              borderColor:"rgba(0,0,0,0)",
                              borderIsThemeColor:false
                            },
                            rectIds: [],
                            layout: {
                              rows:[],
                              cols:[]
                            }
                          },
                          {
                            id:1,
                            options:{
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 200,
                              width: "50%",
                              borderTypeFlag:1,
                              borderRadius:[0,0,0,0],
                              borderWidth:0,
                              borderStyle:"solid",
                              borderColor:"rgba(0,0,0,0)",
                              borderIsThemeColor:false
                            },
                            rectIds: [],
                            layout: {
                              rows:[],
                              cols:[]
                            }
                          }
                        ]
                      }
                    },
                    {
                      id:1,
                      options:{
                        padding: [0, 0, 0, 0],
                        bg: [],
                        height: 200,
                        width: "100%",
                        borderTypeFlag:1,
                        borderRadius:[0,0,0,0],
                        borderWidth:0,
                        borderStyle:"solid",
                        borderColor:"rgba(0,0,0,0)",
                        borderIsThemeColor:false
                      },
                      rectIds: [],
                      layout: {
                        rows:[],
                        cols:[
                          {
                            id:0,
                            options:{
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 200,
                              width: "50%",
                              borderTypeFlag:1,
                              borderRadius:[0,0,0,0],
                              borderWidth:0,
                              borderStyle:"solid",
                              borderColor:"rgba(0,0,0,0)",
                              borderIsThemeColor:false
                            },
                            rectIds: [],
                            layout: {
                              rows:[],
                              cols:[]
                            }
                          },
                          {
                            id:1,
                            options:{
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 200,
                              width: "50%",
                              borderTypeFlag:1,
                              borderRadius:[0,0,0,0],
                              borderWidth:0,
                              borderStyle:"solid",
                              borderColor:"rgba(0,0,0,0)",
                              borderIsThemeColor:false
                            },
                            rectIds: [],
                            layout: {
                              rows:[],
                              cols:[]
                            }
                          }
                        ]
                      }
                    },
                  ],
                  cols: []
                }
              }
            ]
          }
        break
      case 5:
        this.id=1,
          this.options= {
            bg: [],
            padding: [40, 0, 40, 0],
            opacity: 100,
            height: 400,
            paddingTypeFlag: 2,
            isFullPage: false,
            inDocument:'none',
            isFixed:false,
            isShow:true
          },
          this.layout= {
            rows:[
              {
                id:0,
                options: {
                  padding: [0, 0, 0, 0],
                  bg: [],
                  height: 400,
                  width: "100%",
                  borderTypeFlag:1,
                  borderRadius:[0,0,0,0],
                  borderWidth:0,
                  borderStyle:"solid",
                  borderColor:"rgba(0,0,0,0)",
                  borderIsThemeColor:false
                },
                rectIds: [],
                layout: {
                  rows: [
                    {
                      id:0,
                      options:{
                        padding: [0, 0, 0, 0],
                        bg: [],
                        height: 100,
                        width: "100%",
                        borderTypeFlag:1,
                        borderRadius:[0,0,0,0],
                        borderWidth:0,
                        borderStyle:"solid",
                        borderColor:"rgba(0,0,0,0)",
                        borderIsThemeColor:false
                      },
                      rectIds: [],
                      layout: {
                        rows:[],
                        cols:[
                          {
                            id:0,
                            options:{
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 100,
                              width: "50%",
                              borderTypeFlag:1,
                              borderRadius:[0,0,0,0],
                              borderWidth:0,
                              borderStyle:"solid",
                              borderColor:"rgba(0,0,0,0)",
                              borderIsThemeColor:false
                            },
                            rectIds: [],
                            layout: {
                              rows:[],
                              cols:[]
                            }
                          },
                          {
                            id:1,
                            options:{
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 100,
                              width: "50%",
                              borderTypeFlag:1,
                              borderRadius:[0,0,0,0],
                              borderWidth:0,
                              borderStyle:"solid",
                              borderColor:"rgba(0,0,0,0)",
                              borderIsThemeColor:false
                            },
                            rectIds: [],
                            layout: {
                              rows:[],
                              cols:[]
                            }
                          }
                        ]
                      }
                    },
                    {
                      id:1,
                      options:{
                        padding: [0, 0, 0, 0],
                        bg: [],
                        height: 300,
                        width: "100%",
                        borderTypeFlag:1,
                        borderRadius:[0,0,0,0],
                        borderWidth:0,
                        borderStyle:"solid",
                        borderColor:"rgba(0,0,0,0)",
                        borderIsThemeColor:false
                      },
                      rectIds: [],
                      layout: {
                        rows:[],
                        cols:[
                          {
                            id:0,
                            options:{
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 300,
                              width: "33%",
                              borderTypeFlag:1,
                              borderRadius:[0,0,0,0],
                              borderWidth:0,
                              borderStyle:"solid",
                              borderColor:"rgba(0,0,0,0)",
                              borderIsThemeColor:false
                            },
                            rectIds: [],
                            layout: {
                              rows:[],
                              cols:[]
                            }
                          },
                          {
                            id:1,
                            options:{
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 300,
                              width: "34%",
                              borderTypeFlag:1,
                              borderRadius:[0,0,0,0],
                              borderWidth:0,
                              borderStyle:"solid",
                              borderColor:"rgba(0,0,0,0)",
                              borderIsThemeColor:false
                            },
                            rectIds: [],
                            layout: {
                              rows:[],
                              cols:[]
                            }
                          },
                          {
                            id:2,
                            options:{
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 300,
                              width: "33%",
                              borderTypeFlag:1,
                              borderRadius:[0,0,0,0],
                              borderWidth:0,
                              borderStyle:"solid",
                              borderColor:"rgba(0,0,0,0)",
                              borderIsThemeColor:false
                            },
                            rectIds: [],
                            layout: {
                              rows:[],
                              cols:[]
                            }
                          }
                        ]
                      }
                    },
                  ],
                  cols: []
                }
              }
            ]
          }
        break
      case 6:
        this.id=1,
          this.options= {
            bg: [],
            padding: [40, 0, 40, 0],
            opacity: 100,
            height: 400,
            paddingTypeFlag: 2,
            isFullPage: false,
            inDocument:'none',
            isFixed:false,
            isShow:true
          },
          this.layout= {
            rows:[
              {
                id:0,
                options: {
                  padding: [0, 0, 0, 0],
                  bg: [],
                  height: 300,
                  width: "100%",
                  borderTypeFlag:1,
                  borderRadius:[0,0,0,0],
                  borderWidth:0,
                  borderStyle:"solid",
                  borderColor:"rgba(0,0,0,0)",
                  borderIsThemeColor:false
                },
                rectIds: [],
                layout: {
                  rows: [
                    {
                      id:0,
                      options:{
                        padding: [0, 0, 0, 0],
                        bg: [],
                        height: 100,
                        width: "100%",
                        borderTypeFlag:1,
                        borderRadius:[0,0,0,0],
                        borderWidth:0,
                        borderStyle:"solid",
                        borderColor:"rgba(0,0,0,0)",
                        borderIsThemeColor:false
                      },
                      rectIds: [],
                      layout: {
                        rows:[],
                        cols:[]
                      }
                    },
                    {
                      id:1,
                      options:{
                        padding: [0, 0, 0, 0],
                        bg: [],
                        height: 100,
                        width: "100%",
                        borderTypeFlag:1,
                        borderRadius:[0,0,0,0],
                        borderWidth:0,
                        borderStyle:"solid",
                        borderColor:"rgba(0,0,0,0)",
                        borderIsThemeColor:false
                      },
                      rectIds: [],
                      layout: {
                        rows:[],
                        cols:[
                          {
                            id:0,
                            options:{
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 100,
                              width: "33%",
                              borderTypeFlag:1,
                              borderRadius:[0,0,0,0],
                              borderWidth:0,
                              borderStyle:"solid",
                              borderColor:"rgba(0,0,0,0)",
                              borderIsThemeColor:false
                            },
                            rectIds: [],
                            layout: {
                              rows:[],
                              cols:[]
                            }
                          },
                          {
                            id:1,
                            options:{
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 100,
                              width: "34%",
                              borderTypeFlag:1,
                              borderRadius:[0,0,0,0],
                              borderWidth:0,
                              borderStyle:"solid",
                              borderColor:"rgba(0,0,0,0)",
                              borderIsThemeColor:false
                            },
                            rectIds: [],
                            layout: {
                              rows:[],
                              cols:[]
                            }
                          },
                          {
                            id:2,
                            options:{
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 100,
                              width: "33%",
                              borderTypeFlag:1,
                              borderRadius:[0,0,0,0],
                              borderWidth:0,
                              borderStyle:"solid",
                              borderColor:"rgba(0,0,0,0)",
                              borderIsThemeColor:false
                            },
                            rectIds: [],
                            layout: {
                              rows:[],
                              cols:[]
                            }
                          }
                        ]
                      }
                    },
                    {
                      id:2,
                      options:{
                        padding: [0, 0, 0, 0],
                        bg: [],
                        height: 100,
                        width: "100%",
                        borderTypeFlag:1,
                        borderRadius:[0,0,0,0],
                        borderWidth:0,
                        borderStyle:"solid",
                        borderColor:"rgba(0,0,0,0)",
                        borderIsThemeColor:false
                      },
                      rectIds: [],
                      layout: {
                        rows:[],
                        cols:[]
                      }
                    }
                  ],
                  cols: []
                }
              }
            ]
          }
        break
      default:
        this.options= {
          bg: [],
          padding: [40, 0, 40, 0],
          opacity: 100,
          height: 200,
          paddingTypeFlag: 2,
          isFullPage: false,
          inDocument:'none',
          isFixed:false,
          isShow:true
        },
          this.id = 1,
          this.layout= {
            rows:[
              {
                id:0,
                options: {
                  padding: [0, 0, 0, 0],
                  bg: [],
                  height: 200,
                  width: "100%",
                  borderTypeFlag:1,
                  borderRadius:[0,0,0,0],
                  borderWidth:0,
                  borderStyle:"solid",
                  borderColor:"rgba(0,0,0,0)",
                  borderIsThemeColor:false
                },
                rectIds: [],
                layout: {
                  rows: [],
                  cols: []
                }
              }
            ]
          }
    }
    this.objDiff(this, opt)
  }
}

export default {
  page: {
    id: 1,
    name: "大屏模版",
    height: 1920,
    hasHeader: true,
    headerIsFixed: true,
    pageWidth: 1920, //编辑区域宽度
    openComplexFont: false, //开启繁简转换
    themeColor: "#3D82F2",
    children: [new primaryBigScreenGenerator({ container_id: 0, width: 1920, height: 1080 })],
    setting: {
      a5: "template_2_1",
      type: "template_2_bigScreen"
    }
  },
  treeData: [
    {
      id: 0,
      label: "测试模板pc",
      children: [
        {
          id: 0,
          label: "画布0",
          children: []
        }
      ]
    }
  ],
  version: 0,
  type: "bigScreen",
  template_v2_mh: 1
}
